import { u, styled } from '../../../../shared/theming-sc'

const PresetFilterContainer = styled.div`
    float: left;
    width: 100%;
    padding: ${u.getSpacing('medium')}px ${u.getSpacing('large')}px;
    background: ${u.getColor('greyLightest')};
    margin-bottom: 30px;

`

const SavedFilterCol = styled.div`

    width: 100%;
    box-sizing: border-box;
    float: left;


    ${u.media.greaterThan('sm')`
        width: 50%;
    `};

    ${u.media.greaterThan('lg')`
            width: 66%;
    `};

`

const QuickFilterCol = styled.div`
   width: 100%;
    box-sizing: border-box;
    float: left;
    padding-right: ${u.getSpacing('large')}px;
    margin-bottom: ${u.getSpacing('large')}px;

    ${u.media.greaterThan('sm')`
        width: 50%;
        margin-bottom: 0;
    `};

    ${u.media.greaterThan('lg')`
            width: 33%;
            margin-bottom: 0;
    `};
`

const QuickFilterBlock = styled.div`
    width: 100%;
    float: left;
    clear: both;
    border-top: 1px solid ${u.getColor('greyMuted')};
    padding: ${u.getSpacing('small')}px 0px;
    font-weight: bold;
    font-size: ${u.getFontSize('md')};
    cursor: pointer;
    margin-bottom: -1px;

    svg {
        top: 4px;
        margin-right: 10px;
        position: relative;
    }

   ${u.media.greaterThan('sm')`
        margin-bottom: 0;
    `};

    &:last-child {
        border-bottom: 1px solid ${u.getColor('greyMuted')};
    }
`

const QuickFilterBlockSelected = styled.div`
    width: 100%;
    float: left;
    clear: both;
    border-top: 1px solid ${u.getColor('greyDark')};
    padding: ${u.getSpacing('small')}px 0px;
    font-weight: bold;
    font-size: ${u.getFontSize('md')};
    cursor: pointer;
    margin-bottom: -1px;
    position: relative;

    svg {
        top: 4px;
        margin-right: 10px;
        position: relative;
    }

   ${u.media.greaterThan('sm')`
        margin-bottom: 0;
    `};

    &:last-child {
        border-bottom: 1px solid ${u.getColor('greyDark')};
    }

    &:after {
        content: '';
        width: 100%;
        background: #4d4d4d;
        position: absolute;
        bottom: -1px;
        left: 0;
        display: block;
        height: 1px;
    }
`

const SavedFilterBlock = styled.div`
    float: left;
    width: 100%;
    margin-bottom: -1px;
    box-sizing: border-box;
    padding-right: ${u.getSpacing('large')}px;

   ${u.media.greaterThan('lg')`
        width: 50%;
    `};

     svg {
        top: 4px;
        margin-right: 10px;
        position: relative;
    }
`

const SavedFilterInner = styled.div`
    width: 100%;
    float: left;
    border-top: 1px solid ${u.getColor('greyMuted')};
    padding: ${u.getSpacing('small')}px 0px;
    font-weight: bold;
    font-size: ${u.getFontSize('md')};
    cursor: pointer;
    position: relative;

    &:last-child {
        border-bottom: 1px solid ${u.getColor('greyMuted')};
    }
`

const SavedFilterInnerSelected = styled.div`
    width: 100%;
    float: left;
    border-top: 1px solid ${u.getColor('greyDark')};
    padding: ${u.getSpacing('small')}px 0px;
    font-weight: bold;
    font-size: ${u.getFontSize('md')};
    cursor: pointer;
    position: relative;

    &:last-child {
        border-bottom: 1px solid ${u.getColor('greyDark')};
    }

    &:after {
        content: '';
        width: 100%;
        background: #4d4d4d;
        position: absolute;
        bottom: -1px;
        left: 0;
        display: block;
        height: 1px;
    }
`

const SavedFilterRemove = styled.span`
    display: block;
    position: absolute;
    right: 0;
    width: 15px;
    top: 22px;
`

const NoSavedFilters = styled.div`
    width: 100%;
    float: left;
    clear: both;
    border-top: 1px solid ${u.getColor('greyMuted')};
    padding: ${u.getSpacing('small')}px 0px;
    font-weight: bold;
    font-size: ${u.getFontSize('md')};
    margin-bottom: -1px;
    margin-bottom: ${u.getSpacing('small')}px;

    svg {
        top: 4px;
        margin-right: 10px;
        position: relative;
    }

   ${u.media.greaterThan('sm')`
        margin-bottom: 0;
    `};

    &:last-child {
        border-bottom: 1px solid ${u.getColor('greyMuted')};
    }
`

export {
  PresetFilterContainer,
  SavedFilterCol,
  SavedFilterBlock,
  SavedFilterInnerSelected,
  SavedFilterInner,
  SavedFilterRemove,
  QuickFilterCol,
  QuickFilterBlock,
  QuickFilterBlockSelected,
  NoSavedFilters
}
